import TeamDashboardPage from '@/pages/teams/TeamDashboardPage.vue'
import TeamEditPage from '@/pages/teams/TeamEditPage.vue'

const TeamsIndexPage = () => import('@/pages/teams/TeamsIndexPage.vue')

export default [
  { path: "/teams", name: 'teams-index-page', component: TeamsIndexPage },
  { path: "/teams/:teamId", name: 'team-dashboard-page', component: TeamDashboardPage, props: route => ({ teamId: parseInt(route.params.teamId) })  },
  { path: "/teams/:teamId/edit", name: 'team-edit-page', component: TeamEditPage, props: route => ({ teamId: parseInt(route.params.teamId) }) },
]
